import { DateTime } from 'luxon';
import { ActivityMergeData, AttachmentMergeData } from '../../data/activity.merge.data';

export class FakeActivityMergeData extends ActivityMergeData {
    constructor(note: string) {
        super();

        this.attachments = [new FakeAttachmentMergeData("Image", "images/logo-workbuddy.png"), new FakeAttachmentMergeData("Video", "images/logo-workbuddy.png"),];
        this.createdBy = "WorkBuddy Admin";
        this.createdDate = DateTime.local().minus({ days: 5 }).toFormat('dd/MM/yyyy');
        this.note = note;
    }
}

export class FakeAttachmentMergeData extends AttachmentMergeData {
    constructor(type: string, path: string) {
        super();

        this.type = type;
        this.path = path;
        this.thumbnail = path;
        this.title = `Sample ${type}`;
    }
}